import React, { useMemo } from 'react';
import moment from 'moment';
import { get } from 'lodash';

import OrderContent from './OrderContent';
import withAccountLayout from '../../components/account/withAccountLayout';
import AccordionTitle from '../../components/account/AccordionTitle';

moment.locale('de');

function OpenOrders({ orders = [], selectedLocation }) {
    const openOrders = useMemo(() => {
        return orders
            .filter(order =>
                get(order, 'cart.products', []).some(
                    p =>
                        p.orderStatus !== 'completed' &&
                        p.orderStatus !== 'accepted' &&
                        p.orderStatus !== 'captured' &&
                        p.orderStatus !== 'cancelled' &&
                        p.orderStatus !== 'initiated' &&
                        p.orderStatus !== 'completedProductExchange' &&
                        p.orderStatus !== 'reversed' &&
                        p.orderStatus !== 'refunded'
                )
            )
            .filter(order => (selectedLocation ? order.markenStandort._id === selectedLocation : true));
    }, [orders, selectedLocation]);

    return (
        <div className="uk-container">
            <ul data-uk-accordion="multiple: true">
                {openOrders.map(order => {
                    return Object.values(order.productsByLieferweg).map((lieferwege, i) => {
                        if (!lieferwege.length) return null;
                        return (
                            <li key={i} className="uk-open">
                                <AccordionTitle>
                                    <div>Bestelldatum: {moment(order.created).format('LLL')}</div>
                                    <div>Bestell-NR: {order.id}</div>
                                </AccordionTitle>
                                <div className="uk-accordion-content">
                                    <h5>
                                        {lieferwege[0]?.selectedLieferweg?.type === 'montage'
                                            ? 'Abholen in der Filiale inklusive Montage'
                                            : lieferwege[0]?.selectedLieferweg?.bezeichnung}
                                    </h5>
                                    <div className="uk-grid uk-grid-small uk-grid-divider" data-uk-grid="">
                                        {lieferwege.map((product, index) => (
                                            <div key={index} className="uk-width-1-1">
                                                <OrderContent
                                                    orderId={order._id}
                                                    orderNumber={order.id ?? order._id}
                                                    product={product}
                                                    markenStandort={order.markenStandort}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </li>
                        );
                    });
                })}
            </ul>
            {!openOrders.length && (
                <div className="uk-placeholder uk-flex uk-flex-center">Es sind keine Offenen Bestellungen vorhanden.</div>
            )}
        </div>
    );
}

export default withAccountLayout(OpenOrders, { title: 'Meine offenen Bestellungen' });
